var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28722 5.97944L7.67003 9.49983L4.62988 10.8403C4.86302 11.1674 5.00016 11.5676 5.00016 11.9999C5.00016 12.4321 4.86305 12.8323 4.62995 13.1594L7.67003 14.4998L7.28721 18.0203C8.0156 18.125 8.6172 18.6222 8.87077 19.2907L12.0002 16.9998L15.1295 19.2907C15.3831 18.6222 15.9847 18.125 16.7131 18.0203L16.3303 14.4998L19.3704 13.1594C19.1373 12.8323 19.0002 12.4321 19.0002 11.9999C19.0002 11.5676 19.1373 11.1674 19.3704 10.8403L16.3303 9.49983L16.7131 5.97944C15.9847 5.87474 15.3831 5.3775 15.1295 4.70899L12.0002 6.99983L8.87081 4.70898C8.61726 5.3775 8.01564 5.87474 7.28722 5.97944Z",
    fill: "#3CDBC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 4C19 5.10457 18.1046 6 17 6C16.9025 6 16.8067 5.99303 16.7129 5.97955L17 3.33969L15.1293 4.7091C15.0458 4.48871 15 4.2497 15 4C15 2.89543 15.8954 2 17 2C18.1046 2 19 2.89543 19 4Z",
    fill: "#3CDBC1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1294 19.2908C15.0458 19.5112 15 19.7503 15 20C15 21.1046 15.8954 22 17 22C18.1046 22 19 21.1046 19 20C19 18.8954 18.1046 18 17 18C16.9025 18 16.8067 18.007 16.713 18.0204L17 20.6602L15.1294 19.2908Z",
    fill: "#3CDBC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28705 18.0204C7.19331 18.007 7.09747 18 7 18C5.89543 18 5 18.8954 5 20C5 21.1046 5.89543 22 7 22C8.10457 22 9 21.1046 9 20C9 19.7503 8.95423 19.5112 8.87062 19.2908L7 20.6602L7.28705 18.0204Z",
    fill: "#3CDBC1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28706 5.97955C7.19332 5.99303 7.09747 6 7 6C5.89543 6 5 5.10457 5 4C5 2.89543 5.89543 2 7 2C8.10457 2 9 2.89543 9 4C9 4.2497 8.95424 4.48871 8.87065 4.7091L7 3.33969L7.28706 5.97955Z",
    fill: "#3CDBC1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62973 10.8404C4.26713 10.3317 3.6723 10 3 10C1.89543 10 1 10.8954 1 12C1 13.1046 1.89543 14 3 14C3.67234 14 4.2672 13.6682 4.62979 13.1595L2 11.9999L4.62973 10.8404Z",
    fill: "#3CDBC1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3701 13.1595C19.7327 13.6682 20.3276 14 20.9999 14C22.1045 14 22.9999 13.1046 22.9999 12C22.9999 10.8954 22.1045 10 20.9999 10C20.3276 10 19.7328 10.3317 19.3702 10.8404L21.9999 11.9999L19.3701 13.1595Z",
    fill: "#3CDBC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsServices);
export default __webpack_public_path__ + "static/media/icons_services.1c0cd325.svg";
export { ForwardRef as ReactComponent };